"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const IamBase_1 = __importDefault(require("./IamBase"));
class Iam extends IamBase_1.default {
}
module.exports = Iam;
